/**
 * Strip dangerous elements and event handlers from HTML for safe preview rendering.
 * Used by template/signature picker modals and the bulk message email preview.
 *
 * Removes: script execution, iframes, embeds, forms (phishing), style tags
 * (CSS injection/exfiltration), SVG (onload JS), base (URL hijacking),
 * meta (redirect), all on* event handlers / javascript: URLs, and inline style
 * attributes (CSS overlay/tracking-pixel attacks via background-image: url(...)).
 */
const DANGEROUS_ELEMENTS = 'script, iframe, object, embed, style, form, svg, base, meta, noscript, link';

// Attributes that carry URLs and can be vectors for data: URI attacks.
const URL_BEARING_ATTRS = new Set([
  'href',
  'src',
  'action',
  'formaction',
  'xlink:href',
  'poster',
  'background',
  'cite',
]);

// Allow inline images (png/jpeg/gif/webp) inserted by the RTE; block everything else.
const SAFE_DATA_IMAGE_RE = /^data:image\/(png|jpeg|gif|webp);base64,/i;

const sanitizeHtml = (html) => {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll(DANGEROUS_ELEMENTS).forEach((el) => el.remove());
  doc.querySelectorAll('*').forEach((el) => {
    [...el.attributes].forEach((attr) => {
      const name = attr.name.toLowerCase();
      const val = attr.value.trim();
      const valLower = val.toLowerCase();
      if (
        name.startsWith('on') ||
        name === 'style' ||
        valLower.startsWith('javascript:') ||
        valLower.startsWith('vbscript:')
      ) {
        el.removeAttribute(attr.name);
      } else if (URL_BEARING_ATTRS.has(name) && valLower.startsWith('data:') && !SAFE_DATA_IMAGE_RE.test(val)) {
        el.removeAttribute(attr.name);
      }
    });
  });
  return doc.body.innerHTML;
};

export default sanitizeHtml;
